export default __webpack_public_path__ + "static/media/ninja_coffee_makers.e012284c.png";